import {
  getExternalLink,
  hasImage,
  isExternal,
  isRegistrationClosedVisible,
  isRegistrationScheduled,
  isRegistrationWithCustomDates,
  isTicketed,
  isWithoutRegistration,
  saleScheduledAndHasTickets,
} from '@wix/wix-events-commons-statics'
import {withTranslation} from '@wix/yoshi-flow-editor'
import {getHomePageUrl, isMobile} from '../../../../../../commons/selectors/environment'
import {isMemberRsvpExists} from '../../../selectors/member-rsvp'
import {getTickets} from '../../../selectors/tickets'
import {DetailsPageAppProps} from '../../app/interfaces'
import {connect} from '../../runtime-context/context'
import {RegistrationButtonOwnProps, RegistrationButtonRuntimeProps} from './interfaces'
import {RegistrationButton as Presentation} from './registration-button'

const mapRuntime = ({state}: DetailsPageAppProps): RegistrationButtonRuntimeProps => {
  const event = state.event
  const componentSettings = state.component.settings
  const ticketedEvent = isTicketed(event)

  return {
    registrationClosed: isRegistrationClosedVisible(event),
    withoutRegistration: isWithoutRegistration(event),
    memberRsvpExists: isMemberRsvpExists(state),
    ticketedEvent,
    componentSettings,
    imageVisible: hasImage(event),
    isMobile: isMobile(state),
    ticketsUnavailable:
      ticketedEvent && (!getTickets(state).length || getTickets(state).every(saleScheduledAndHasTickets)),
    url: getExternalLink(event),
    isExternalLink: isExternal(event),
    registrationScheduled: isRegistrationScheduled(event),
    registrationWithCustomDates: isRegistrationWithCustomDates(event),
    eventId: event.id,
    homePageUrl: getHomePageUrl(state),
  }
}

export const RegistrationButton = withTranslation()(
  connect<RegistrationButtonOwnProps, RegistrationButtonRuntimeProps>(mapRuntime)(Presentation),
)

export * from './interfaces'
